import Vue from 'vue'
import Vuetify from 'vuetify'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import filters from './filters'
import axios from 'axios'
import VueAxios from 'vue-axios'
import colors from 'vuetify/es5/util/colors'
import 'vuetify/dist/vuetify.min.css'
import firebase from 'firebase'

Vue.config.productionTip = false
Vue.use(VueAxios, axios);
Vue.use(Vuetify, {
  theme: {
    primary: colors.blueGrey.darken3, // #E53935
    secondary: colors.grey.lighten4, // #FFCDD2
    accent: colors.indigo.base // #3F51B5
  }
});

new Vue({
  store,
  router,
  filters,
  Vuetify,
  render: h => h(App),
  created() {
    firebase.auth().onAuthStateChanged((firebaseUser) => {
      if (firebaseUser) {
        store.dispatch('autoSignIn', firebaseUser.email);
      }
    })
  }
}).$mount('#app')
